import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    // Debounce function to limit how often checkMobile runs
    let resizeTimer;

    const checkMobile = () => {
      const mobile = (window.innerWidth >= 320 && window.innerWidth <= 480)
        ||
        (window.innerWidth >= 480 && window.innerWidth <= 768);
      const tablet = (window.innerWidth >= 480 && window.innerWidth <= 768);
      setIsMobile(mobile);
      setIsTablet(tablet);
      console.log(mobile, tablet);
    };

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkMobile, 100); // Wait 100ms after last resize event
    };

    // Check on initial load
    checkMobile();

    // Add debounced event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="logo">
          <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/logo512.png" alt="Logo" style={{ height: '32px', marginRight: '2px' }} />
            <span className="logo-text">GimmeResume</span>
          </Link>
        </div>
        <div className="navbar-trailing">
          {(isTablet) && (
            <div className="btn-navbar">
              No subscription required
            </div>
          )}
          <input type="checkbox" id="mobile-menu-toggle" className="mobile-menu-checkbox" />
          {isMobile && (

            <label htmlFor="mobile-menu-toggle" className="mobile-menu-label">
              <div className="hamburger-icon">
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
              </div>
            </label>
          )}
          <div className="nav-links">
            {isMobile && !isTablet && (
              <div className="btn-navbar-mobile">
                No subscription required
              </div>
            )}
            <Link to={{ pathname: "/", hash: "#product" }} className="nav-link">Product</Link>
            <Link to={{ pathname: "/", hash: "#features" }} className="nav-link">Features</Link>
            <Link to="/blog" className="nav-link">Blog</Link>
            <Link to={{ "pathname": "/", hash: "#faq" }} className="nav-link">FAQ</Link>
            {(!isMobile) && (
              <div className="btn-navbar">
                No subscription required
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;